<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Phone Off" class="d-icon d-icon--phone-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor"><path d="M11.354 1.354a.5.5 0 0 0-.708-.708l-10 10a.5.5 0 0 0 .708.708l2.838-2.84c2.108 1.826 4.503 2.31 5.628 2.439.67.077 1.18-.463 1.18-1.077V8.738c0-.516-.352-.966-.853-1.091l-1.439-.359a1.125 1.125 0 0 0-1.068.296L6.394 8.832A8.88 8.88 0 0 1 4.9 7.806l6.453-6.452ZM7.35 9.289a9.893 9.893 0 0 0 2.583.67.05.05 0 0 0 .023-.002.046.046 0 0 0 .017-.01.096.096 0 0 0 .026-.072V8.738a.125.125 0 0 0-.095-.121l-1.439-.359a.125.125 0 0 0-.118.033l-.997.998ZM2.007 2.05c0-.009.001-.013.002-.016a.035.035 0 0 1 .009-.011A.093.093 0 0 1 2.083 2H3.26c.057 0 .107.04.121.095L3.73 3.49a.125.125 0 0 1-.041.126l-1.128.941a7.987 7.987 0 0 1-.554-2.508ZM4.33 4.385 3.001 5.493c.125.226.266.455.424.684a.5.5 0 0 1-.823.568A9.075 9.075 0 0 1 1.009 2.1C.977 1.457 1.506 1 2.083 1H3.26c.516 0 .966.351 1.091.852l.35 1.396c.104.42-.04.86-.372 1.137Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconPhoneOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
